import axios from "../axios";
import h from "../helpers";

const sizeVariant = {
  index: async (params) => {
    const { data } = await axios.get(h.baseUrl("size-variants"), {
      params: { ...params },
    });
    return data;
  },
  show: async (id) => {
    const { data } = await axios.get(h.baseUrl("size-variants/" + id));
    return data;
  },
  store: async (name) => {
    const { data } = await axios.post(h.baseUrl("size-variants"), {
      name,
    });
    return data;
  },
  update: async (id, name) => {
    const { data } = await axios.put(h.baseUrl("size-variants/" + id), {
      name,
    });
    return data;
  },
  delete: async (id) => {
    const { data } = await axios.delete(h.baseUrl("size-variants/" + id));
    return data;
  },
};

export default sizeVariant;
